import { Component } from '@angular/core';

@Component({
  selector: 'ngx-landing-layout',
  styleUrls: ['landing.layout.scss'],
  template: `
    <nb-layout windowMode="false">
        <nb-layout-column>
            <ng-content select="router-outlet"></ng-content>
        </nb-layout-column>
    </nb-layout>
  `,
})
export class LandingLayoutComponent {}
